import { render, staticRenderFns } from "./MaintenanceReportsView.vue?vue&type=template&id=7950c54d&scoped=true&"
import script from "./MaintenanceReportsView.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceReportsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7950c54d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7950c54d')) {
      api.createRecord('7950c54d', component.options)
    } else {
      api.reload('7950c54d', component.options)
    }
    module.hot.accept("./MaintenanceReportsView.vue?vue&type=template&id=7950c54d&scoped=true&", function () {
      api.rerender('7950c54d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/maintenance-reports/views/MaintenanceReportsView.vue"
export default component.exports